import { h } from 'preact'; /** @jsx h */

import './Paragraph.scss';

const Paragraph = ({
    type = 'normal',
    className = '',
    color = '',
    text,
    photo,
    video,
    textAndPhoto,
    children
}) => {
    if (type === 'normal')
        return (
            <p className={`paragraph paragraph-${type} ${color && `color-${color}`} ${className}`}>
                {children}
            </p>
        );

    if (type === 'ingress')
        return (
            <p className={`paragraph paragraph-${type} ${color && `color-${color}`} ${className}`}>
                {children}
            </p>
        );

    if (type === 'byline')
        return (
            <p className={`paragraph paragraph-${type} ${color && `color-${color}`} ${className}`}>
                <i>
                    {text && `Tekst: ${text}`}
                    {text && photo && <br />}
                    {photo && `Foto: ${photo}${video ? ' /' : ''}`} {video && `Video: ${video}`}
                    {textAndPhoto && `Tekst og foto: ${textAndPhoto}`}
                </i>
            </p>
        );

    if (type === 'background')
        return (
            <div
                className={`paragraph paragraph-${type} ${color && `color-${color}`} ${className}`}
            >
                <p className={`paragraph`}>{children}</p>
            </div>
        );
    if (type === 'link')
        return (
            <div
                className={`paragraph paragraph-${type} ${color && `color-${color}`} ${className}`}
            >
                <p className={`paragraph`}>
                    <b>Les også: </b>
                    <a href="/nyheter/emil-persgard-tildeles-livredderprisen/" className="link">
                        {children}
                    </a>
                </p>
            </div>
        );
};

export default Paragraph;
